<template>
  <el-drawer size="520px"
             :withHeader="false"
             :visible.sync="detailVisible"
             :close-on-press-escape="false"
             :wrapperClosable="false"
             :before-close="handleClickClose">
    <div class="drawer_wrap">
      <div class="drawer_header">
        <h3 class="title" style="">公司详情</h3>
        <i class="el-icon-close" @click="handleClickClose"></i>
      </div>
      <div class="dialog_wrap drawer_body">
      <div class="title" style="margin-top: 0"><span>基本信息</span></div>
      <div class="dialog_top_wrap">
        <div class="top">
          <div class="top_cover">
            <img :src="companyForm.company_logo ? companyForm.company_logo : 'https://www.enlightv.com/Public/Admin/img/ljylogo.png'" alt="">
          </div>
          <div class="top_content">
            <div class="company_name">
                <p v-text="companyForm.auth_company_name"></p>
            </div>
            <div class="authentication">
              <span class="authentication_status1" v-if="companyForm.auth_status == 0"><i class="iconfont icon-shouquan"></i>未认证</span>
              <span class="authentication_status2" v-if="companyForm.auth_status == 2"><i class="iconfont icon-shenpizhong"></i>审核中</span>
              <span class="authentication_status2" v-if="companyForm.auth_status == 1"><i class="iconfont icon-shouquan"></i>已认证</span>
              <span class="authentication_status3" v-if="companyForm.auth_status == 3"><i class="iconfont icon-shenpizhong"></i>已拒绝</span>

            </div>

          </div>
        </div>
        <div class="bottom">
            <div class="field_item">
              <div class="field_label">行业类型：</div>
              <div class="field_value" v-text="companyForm.industry_type +'/'+ companyForm.industry_type_sub"></div>
            </div>
            <div class="field_item">
              <div class="field_label">人员规模：</div>
              <div class="field_value" v-text="companyForm.personnel_size"></div>
            </div>
            <div class="field_item">
              <div class="field_label">公司所在地区：</div>
              <div class="field_value" v-text="companyForm.province ? companyForm.province +'/'+  companyForm.city  +'/'+ companyForm.area : '-'"></div>
            </div>
            <div class="field_item">
              <div class="field_label">详细地址：</div>
              <div class="field_value" v-text="companyForm.addr ? companyForm.addr : '-'"></div>
            </div>
            <div class="field_item">
              <div class="field_label">公司联系人：</div>
              <div class="field_value" v-text="companyForm.contact_name"></div>
            </div>
            <div class="field_item">
              <div class="field_label">联系人手机：</div>
              <div class="field_value" v-text="companyForm.contact_phone"></div>
            </div>
            <div class="field_item">
              <div class="field_label">职务：</div>
              <div class="field_value" v-text="companyForm.position ?companyForm.position :'-'"></div>
            </div>
            <div class="field_item">
              <div class="field_label">座机：</div>
              <div class="field_value" v-text="companyForm.company_tel ? companyForm.company_tel : '-'"></div>
            </div>
            <div class="field_item">
              <div class="field_label">邮箱：</div>
              <div class="field_value" v-text="companyForm.company_email ? companyForm.company_email : '-'"></div>
            </div>
        </div>

      </div>
      <div class="title" v-if="companyForm.auth_status != 0"><span>认证信息</span></div>
      <div class="dialog_top_wrap"  v-if="companyForm.auth_status != 0">
        <div class="bottom">
          <div class="field_item">
            <div class="field_label">企业名称：</div>
            <div class="field_value" v-text="companyForm.auth_company_name"></div>
          </div>
          <div class="field_item">
            <div class="field_label">统一社会信用代码：</div>
            <div class="field_value" v-text="companyForm.credit_code"></div>
          </div>
          <div class="field_item">
            <div class="field_label">营业执照：</div>
            <div class="field_value">
              <div class="upload_flex">
                <div class="upload_btn_wrap">
                  <div class="upload_img_wrap">
                    <el-image class="img" :src="companyForm.business_license" alt="" v-if="companyForm.business_license" :preview-src-list="[companyForm.business_license]"></el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field_item">
            <div class="field_label">法定代表人姓名：</div>
            <div class="field_value" v-text="companyForm.legal_name"></div>
          </div>
          <div class="field_item">
            <div class="field_label">法定身份证号码：</div>
            <div class="field_value" v-text="companyForm.legal_idcard"></div>
          </div>
          <div class="field_item">
            <div class="field_label">法人身份证照片：</div>
            <div class="field_value">
              <div class="upload_flex">
                <template v-for="photo in companyForm.legal_idphoto">
                  <div class="upload_btn_wrap" v-if="photo.type == 'ago'">
                    <div class="upload_img_wrap">
                      <el-image class="img" :src="photo.file_path" alt="" v-if="photo.file_path"  :preview-src-list="[photo.file_path]"> </el-image>
                    </div>
                  </div>
                  <div class="upload_btn_wrap" v-if="photo.type == 'back'">
                    <div class="upload_img_wrap">
                      <el-image class="img" :src="photo.file_path" alt="" v-if="photo.file_path" :preview-src-list="[photo.file_path]"> </el-image>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
    </div>
  </el-drawer>
</template>
<script>

import { authDetails} from '@/api'
export default {
  name: 'detail',
  props: {
    detailVisible: {
      type: Boolean,
      default: false,
    },
    companyId: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      loading: false,
      companyForm: {},
    }
  },
  computed: {

  },
  mounted() {
    if(this.companyId){
      this.getAuthDetails()
    }
  },
  methods: {
    getAuthDetails(){
      authDetails({
        company_id: this.companyId
      }).then(res => {
        if (res.code === 200) {
          this.companyForm = res.data
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
    //取消事件
    handleClickClose() {
      //关闭对话框
      this.$emit('update:detailVisible', false)
    },
  }


}
</script>
<style lang="scss" scoped>
.title{
  line-height: 32px !important;
  margin-top: 24px;
  margin-bottom: 16px;
  position: relative;
}
.title span{
  font-size: 14px;
  padding-left: 8px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.title::before{
  display: none;
}
.title span::after{
  content: ' ';
  width: 4px;
  height: 22px;
  top: 5px;
  left: 0;
  border-radius: 4px;
  background: #1990ff;
  position: absolute;
}
.dialog_top_wrap{
  width: 100%;
}
.dialog_top_wrap .top{
  display: flex;
  justify-content: space-between;
}
.dialog_top_wrap .top .top_cover{
  border: 1px solid rgba(232, 232, 232, 1);
  width: 68px;
  height: 68px;
  border-radius: 4px;
  position: relative;
}
.dialog_top_wrap .top .top_cover img{
  display: block;
  width: 66px;
  height: 66px;
  object-fit: cover;
}
.dialog_top_wrap .top .top_content{
  width: calc(100% - 80px);
}
.dialog_top_wrap .top .top_content .company_name{
  line-height: 32px;
  color:rgba(51, 51, 51, 1) ;
  font-size: 14px;
}

.dialog_top_wrap  .top .top_content .authentication{
  margin-top: 10px;
}
.dialog_top_wrap  .top .top_content .authentication .el-button--mini{
  padding: 5px 7px;
  margin-left: 10px;
}
.dialog_top_wrap  .top .top_content .authentication .authentication_status1{
  display: inline-block;
  padding: 0 8px;
  line-height: 24px;
  border-radius: 2px;
  background: rgba(25, 144, 255, 0.1);
  font-size: 14px;
  color: rgba(25, 144, 255, 1);
  cursor: pointer;
}
.dialog_top_wrap  .top .top_content .authentication .authentication_status1 i.icon-shouquan{
  margin-right: 4px;
}
.dialog_top_wrap  .top .top_content .authentication .authentication_status2{
  display: inline-block;
  padding: 0 8px;
  line-height: 24px;
  border-radius: 2px;
  background: rgba(251, 173, 19, 0.1);
  font-size: 14px;
  color: rgba(251, 173, 19, 1);
}
.dialog_top_wrap  .top .top_content .authentication .authentication_status2 i{
  margin-right: 4px;
}
.dialog_top_wrap  .top .top_content .authentication .authentication_status3{
  display: inline-block;
  padding: 0 8px;
  line-height: 24px;
  border-radius: 2px;
  background: rgba(255, 77, 79, .1);
  font-size: 14px;
  color: rgba(255, 77, 79, 1);
}
.dialog_top_wrap  .bottom{
  margin-top: 24px;
}

.dialog_top_wrap  .bottom .field_item{
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.dialog_top_wrap  .bottom .field_item .field_label{
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
  line-height: 22px;
}
.dialog_top_wrap  .bottom .field_item .field_value{
  flex: 1;
  color: rgba(51, 51, 51, 1);
  text-align: left;
}




.upload_flex{
  display: flex;
}
.upload_btn_wrap{
  width: 144px;
  height: 90px;
  position: relative;
  border-radius: 4px;
  border: 1px solid rgba(209, 228, 239, 1);
  box-sizing: border-box;
  overflow: hidden;
  margin-right: 24px;
}

.upload_btn_wrap .upload_img_wrap{
  width: 100%;
  position: relative;
  border: none;
}
.upload_btn_wrap .upload_img_wrap .img{
  display: block;
  width: 100%;
  height: 88px;
  object-fit: cover;
}
</style>
